import { configReportPlatformError } from "$root/api/error-reporting";
import { hasAccess } from "$root/components/AuthorizationGuard";
import { initHotjarCUser } from "$root/third-party-integrations/initHotjar";
import initIntercom, { disposeIntercomUser, initIntercomCUser } from "$root/third-party-integrations/initIntercom";
import initIubendaPriv from "$root/third-party-integrations/initIubendaPriv";
import { configMixPanel, initMixPanelCUser } from "$root/third-party-integrations/initMixPanel";
import { observe } from "@mdotm/shadcn/legacy/reactivity";
import { user$ } from ".";
import { installAuthInterceptors } from "./auth-interceptors";
import { installCrossTabSessionSync } from "./cross-tab-session";

export function initAuth(): void {
	installAuthInterceptors();
	// Both live for the lifetime of the document, so neither disposer is kept.
	installCrossTabSessionSync();

	observe((get) => {
		const newUser = get(user$);
		// Init Signed Chat Intercom
		disposeIntercomUser();
		if (newUser.signedIn) {
			initIubendaPriv();
			if (hasAccess(newUser, { requiredService: "HELP_CENTER" })) {
				initIntercom();
				initIntercomCUser(newUser);
			}
		}

		configReportPlatformError({ uid: newUser.signedIn ? newUser.email : null });

		// Configure and Init Signed Mixpanel
		configMixPanel({
			uid: newUser.email,
			impersonating: newUser.impersonating,
			isInternal: newUser.email ? newUser.email.toLowerCase().includes("mdotm") : false,
		});

		initMixPanelCUser(newUser);
		// Init Signed Hotjar
		initHotjarCUser(newUser);
	});
}
